import { useScrollReveal } from "@/hooks/useScrollReveal";
import { useState } from "react";

export default function OurPartners() {
  const { ref, isVisible } = useScrollReveal();
  const [hoveredCard, setHoveredCard] = useState(null);

  const partners = [
    [
      { name: "Snapchat", logoGray: "https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/enfinity/gray-snapchat.svg", logoColor: "https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/enfinity/color-snapchat.svg", hoverColor: "bg-[#FFFC00]" },
      { name: "Google", logoGray: "https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/enfinity/gray-google.svg", logoColor: "https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/enfinity/color-google.svg", hoverColor: "bg-white", hasShadow: true },
      { name: "YouTube", logoGray: "https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/enfinity/gray-youtube.svg", logoColor: "https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/enfinity/color-youtube.svg", hoverColor: "bg-[#FF0000]" },
    ],
    [
      { name: "Facebook", logoGray: "https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/enfinity/gray-facebook.svg", logoColor: "https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/enfinity/color-facebook.svg", hoverColor: "bg-[#1877F2]" },
      { name: "Instagram", logoGray: "https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/enfinity/gray-instagram.svg", logoColor: "https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/enfinity/color-instagram.svg", hoverColor: "gradient", gradientColors: ["#FFD521", "#FFD521", "#D7005A", "#B900B4", "#B900B4"] },
      { name: "TikTok", logoGray: "https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/enfinity/gray-tiktok.svg", logoColor: "https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/enfinity/color-tiktok.svg", hoverColor: "bg-[#000000]" },
    ],
    [
      { name: "Twitch", logoGray: "https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/enfinity/gray-twitch.svg", logoColor: "https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/enfinity/color-twitch.svg", hoverColor: "bg-[#9147FE]" },
      { name: "Microsoft", logoGray: "https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/enfinity/gray-microsoft.svg", logoColor: "https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/enfinity/color-microsoft.svg", hoverColor: "bg-white", hasShadow: true },
      { name: "Kuaishou", logoGray: "https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/enfinity/gray-video.svg", logoColor: "https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/enfinity/color-video.svg", hoverColor: "bg-[#FF3D13]" },
      { name: "Venntilate", logoGray: "https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/enfinity/gray-venntilate.svg", logoColor: "https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/enfinity/color-venntilate.svg", hoverColor: "bg-black", hasShadow: true },
    ],
  ];

  return (
    <div
      ref={ref}
      className={`${
        isVisible ? "" : ""
      } bg-white py-20 lg:py-32 px-4 xxs:px-8 xs:px-10 sm:px-10 md:px-10 lg:px-6 xl:px-8 4xl:px-16`}
    >
      <div className="max-w-7xl mx-auto space-y-12">
        {/* Header Section */}
        <div className="flex flex-col items-center gap-4 xxs:gap-4 xs:gap-5 sm:gap-5 md:gap-6 lg:gap-6">
          <p className="text-[#757575] text-sm xxs:text-sm xs:text-base sm:text-base md:text-lg lg:text-lg 4xl:text-[24px] font-medium enfinity-subtext-font">Who we work with</p>
          
          <h1 className="text-4xl xxs:text-[55px] lg:text-[80px] 4xl:text-[90px] font-normal text-black text-center leading-tight xxs:leading-tight xs:leading-tight sm:leading-tight md:leading-tight lg:leading-[106px] max-w-[1105px] enfinity-header-font">
            <span className="block xxs:block xs:block sm:block md:inline lg:inline enfinity-header-font">Leading </span>
            <span
              className="bg-clip-text text-transparent block xxs:block xs:block sm:block md:inline lg:inline enfinity-header-font"
              style={{
                backgroundImage:
                  "linear-gradient(to right, #00b0ff, #9c44e9)",
              }}
            >
              brands & partners
            </span>
            <span className="block xxs:block xs:block sm:block md:inline lg:inline enfinity-header-font"> working with Enfinity</span>
          </h1>
        </div>

        {/* Partners Grid */}
        <div className="flex flex-col gap-6">
          {partners.map((row, rowIndex) => (
            <div key={rowIndex} className="flex flex-col lg:flex-row gap-6 justify-start">
              {row.map((partner, colIndex) => {
                const getHoverStyle = () => {
                  if (partner.hoverColor === "gradient") {
                    return {
                      backgroundImage: 'linear-gradient(135deg, #FFD521 0%, #FFD521 20%, #D7005A 50%, #B900B4 80%, #B900B4 100%)',
                      boxShadow: "0px 2px 6px 0px rgba(0,0,0,0.1)"
                    };
                  }
                  
                  const colorMap = {
                    "bg-[#FFFC00]": "#FFFC00",
                    "bg-white": "#FFFFFF",
                    "bg-[#FF0000]": "#FF0000",
                    "bg-[#1877F2]": "#1877F2",
                    "bg-[#000000]": "#000000",
                    "bg-black": "#000000",
                    "bg-[#9147FE]": "#9147FE",
                    "bg-[#FF3D13]": "#FF3D13",
                  };
                  
                  const bgColor = colorMap[partner.hoverColor] || "#FFFFFF";
                  const shadow = partner.hasShadow 
                    ? "0px 4px 6px rgba(0,0,0,0.1)" 
                    : "0px 2px 6px rgba(0,0,0,0.1)";
                  
                  return {
                    backgroundColor: bgColor,
                    boxShadow: shadow
                  };
                };
                
                const cardId = `${rowIndex}-${colIndex}`;
                const isHovered = hoveredCard === cardId;
                
                // Custom sizing for specific partners
                const getImageSize = () => {
                  switch (partner.name) {
                    case "Facebook":
                      return "max-w-[250px] max-h-[300px] w-auto h-auto object-contain";
                    case "Instagram":
                      return "max-w-[220px] max-h-[270px] w-auto h-auto object-contain";
                    case "Twitch":
                      return "max-w-[200px] max-h-[200px] w-auto h-auto object-contain";
                    case "TikTok":
                      return "max-w-[200px] max-h-[140px] w-auto h-auto object-contain";
                    case "Microsoft":
                      return "max-w-[240px] max-h-[240px] w-auto h-auto object-contain";
                    case "Snapchat":
                      return "max-w-[200px] max-h-[240px] w-auto h-auto object-contain";
                    case "Kuaishou":
                      return "max-w-[200px] max-h-[240px] w-auto h-auto object-contain";
                    case "Venntilate":
                      return "max-w-[200px] max-h-[80px] w-auto h-auto object-contain";
                    default:
                      return "max-w-[250px] max-h-[120px] w-auto h-auto object-contain";
                  }
                };
                
                return (
                  <div
                    key={cardId}
                    className="bg-[#f1f1f1] transition-all duration-300 flex items-center justify-center px-8 lg:px-[57.311px] py-8 lg:py-[54.397px] rounded-[20px] w-full lg:w-[434.67px] h-[210px] cursor-pointer overflow-hidden"
                    onMouseEnter={(e) => {
                      setHoveredCard(cardId);
                      const hoverStyle = getHoverStyle();
                      Object.assign(e.currentTarget.style, hoverStyle);
                    }}
                    onMouseLeave={(e) => {
                      setHoveredCard(null);
                      e.currentTarget.style.backgroundColor = "";
                      e.currentTarget.style.backgroundImage = "";
                      e.currentTarget.style.boxShadow = "";
                    }}
                  >
                    <img
                      src={isHovered ? partner.logoColor : partner.logoGray}
                      alt={partner.name}
                      className={`${getImageSize()} transition-opacity duration-50`}
                    />
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
